import React, { useState } from "react";
import NormalInputField from "../../../../components/inputs/NormalInputField";
import { getToken, saveToken } from "../../../../utils/token";
import instance from "../../../../axios/instance";
import { Link, Outlet, useLoaderData, useLocation } from "react-router-dom";
import { CalendarDays, SlidersHorizontal } from "lucide-react";
import { NoAccessInfo } from "../../../../components/NoAccessInfo";

export const treatmentSetupLoader = async () => {
  const token = getToken();
  const plan = await instance.get("/doctor/billing/plan/active", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const user = await instance.get("/doctor", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return { plan: plan.data, user: user.data };
};

export const TreatmentSetup = () => {
  const { plan, user } = useLoaderData();
  const location = useLocation();
  const noWebsiteAccess = plan.noAccess.includes("website");

  const tabs = [
    {
      id: 1,
      path: "/dashboard/settings/treatment-setup",
      key: "treatment-setup",
      name: "Providers",
      icon: <CalendarDays size={20} />,
    },
    {
      id: 2,
      path: "/dashboard/settings/treatment-setup/treatments",
      key: "treatments",
      name: "Treatments",
      icon: <SlidersHorizontal size={20} />,
    },
  ];

  const locationArr = location.pathname.split("/");
  const locationLastItems = locationArr.slice(locationArr.length - 1);
  const isAdmin = user.access === "admin";

  return (
    <div className={`max-h-[90vh] bg-white`}>
      {isAdmin && (
        <div className="bg-[#fafafa] px-4 w-full border-r flex gap-x-2">
          {tabs.map((tab) => (
            <Link
              to={tab.path}
              key={tab.id}
              className={`flex items-center gap-x-3 px-3 rounded-md py-2 border-2 my-3 ${
                locationLastItems.includes(tab.key)
                  ? "text-primary border-primary-light"
                  : "text-black border-transparent"
              } hover:border-primary-light text-sm`}
            >
              {tab.icon}
              {tab.name}
            </Link>
          ))}
        </div>
      )}
      <div className="basis-full max-h-[80vh] overflow-y-scroll scrollbar-hide">
        {noWebsiteAccess ? (
          <div className="px-7 py-5">
            <NoAccessInfo
              msg={`Your current plan (${plan.name}) does not include an external website feature`}
            />
          </div>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
};
